/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { openWithDesktop } from '@tencent/docs-scenario-component-navigate-client-pc';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import ClipboardManager from '../clipboard/clipboard-manager';
import { IS_IN_TENCENTCLIPBOARD_COPY_STATUS } from '../clipboard/clipboard-libs';
import CPUtils, { EventType, ServicesProvider as CPUtilsServicesProvider, EventTypeValue } from '../cp-utils';
import i18n from '@i18next/i18n';
import ParsePasteHTML from '../lib/ParsePasteHTML';
import { TaskPriority } from '@src/slide/infrastructure/module/dependent/taskManager';
import Snackbar from '@tencent/dui/lib/components/Snackbar/index';
import StoreManager, { DataModel, ISdkModel, ITextBodyModel, ITextBodyModelVersion2 } from '../store-manager';
import Textarea from '../lib/textarea';
import ua from '@tencent/docs-user-agent';
import { emuToCanvas, emuToPt } from '@src/slide/infrastructure/module/independent/unit';
import { dragBaseLogic, getDragPPTList } from '../cp-ppt';
import { ElementHTML, ElementInheritHTML, HTMLType } from '../plugin/html-prepare-plugin';
import { showTipToCopyCustomerDataToImage, showTipWhenDataNotReady, showTipWhenChart, showTipWhenIsSmartArt } from '../components/snackbar';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TextType } from '../plugin/text-prepare-plugin';
import { getQuery } from 'sutils';
import {
    replaceImage,
    pasteImageData,
} from '../cp-image';
import {
    pastePureTextAsNewShape,
    pasteTextDataAsNewShape,
    generateShapeDataFromText,
    CPHtmlInjectable,
    pasteTables,
} from '../cp-html';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import type ElementBaseModel from '@src/slide/domain/ui-model/element-modeles/base-modeles/element-base-model';
import { ImageEditManager } from '@src/slide/application/service/copy-paste/core/cp-image.new';
import { ImageCanvasOptions } from '../plugin/types';
import {
    ISlideModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';
import { ENABLE_IMPORT_FILE } from '@editor/src/js/constants/right-menu-data';
import { IMAGE_SRC_KEY } from '../cp-constants';
import ImageQuickLookManager from '../../../../../infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';
import ImageUrl from '../../../../../infrastructure/module/dependent/image/image-toolkit/image-url';
import { ImageResource } from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-resource';
import { isBVisitC } from '@src/js/common/utils';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ClipboardType } from '../types';
import { isSupportPPTType } from '@editor/src/js/constants/import';
import { PasteSdkHandler } from '@src/slide/application/service/copy-paste/core/paste/paste-sdk-handler';
import { DataType, IPresentationDataModel, IShapeData } from '@tencent/slide-sdk-model';
import { TextConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/text/text-converter';
import { ShapePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/shape-property-converter';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import _cloneDeep from 'lodash/cloneDeep';
import CopySpecialUtils from '@src/slide/application/service/copy-paste/core/paste/paste-special/copy-special-utils';
import { CopyDataVersion, IClipboardData } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';
import { SlideDataMigrator } from '@tencent/slide-sdk-data-migration';
import { ENABLE_PASTE_SPECIAL } from '@src/slide/infrastructure/module/dependent/config/renderer/switch';
import { ClipboardData, CopyItem, IBaseCopyPaste, ICopyPasteServiceDelegates } from './base-copy-paste.interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { PlaceHolderMode } from '@src/slide/domain/ui-model/element-modeles/property/placeholder/PlaceHolderMode';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import EditorImage
    from '@src/slide/application/service/copy-paste/core/cp-image.new/image-edit-manager/core/editor-image';
import ShapeModel from '@src/slide/domain/ui-model/element-modeles/shape-model';
import type { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { isEmptyModel, isShapeModel, isTableModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { DeepPartial } from 'ts-essentials';
import { pasteSpecialEventBus } from '@src/slide/application/service/copy-paste/core/paste/paste-special/event-bus';
import { PanelType } from '@src/framework/frame-pc/components/paste-special-panel/interface';
import { ICopyPasteInjectable } from '@src/slide/application/service/copy-paste/inject/copy-paste-injectable.interface';
import AttachmentUploader, { FILE_TYPE } from '@src/js/common/ark-extensions/dc-components/attachment-uploader';

enum ComponentsType {
    SLIDE = 'slide',
    SHAPE = 'shape',
    PICTURE = 'pic',
    GROUPSHAPE = 'groupShape',
    CONNECTOR = 'cxnSp',
    TABLE = 'graphFrame_Tbl',
    MASTER = 'master',
    LAYOUT = 'layout',
    SECTION = 'section',
    CHART = 'chart',
}

const SupportTypesFromV2toV3 = [
    ComponentsType.SLIDE,
    ComponentsType.LAYOUT,
    ComponentsType.SECTION,
    ComponentsType.SHAPE,
    ComponentsType.GROUPSHAPE,
    ComponentsType.PICTURE,
    ComponentsType.CONNECTOR,
    ComponentsType.TABLE,
    ComponentsType.CHART,
];

export abstract class BaseCopyPaste implements IBaseCopyPaste {
    private pasteSdkHandler: PasteSdkHandler;
    private forceAsyncModel: false;
    protected textarea = Textarea.getSingleton();

    snackbarOp: any;
    copyElementDataUrl;
    isCut = false;
    enable = true;
    dragStatus = {
        isDragged: false,
        enableDrop: false,
    };
    tableCannotPasteTip;
    inTest = false;
    isSafariLower15 = this.judgeSafariVersion();
    clipboardManager: ClipboardManager;
    storeManager: StoreManager;
    public readonly imageEditManager: ImageEditManager;
    public services?: Partial<ICopyPasteServiceDelegates>;
    public copyPasteInjectable: ICopyPasteInjectable;
    /**
     * 在元素上拖拽释放后，保存元素Model信息，在copy-paster中处理
     */
    savedDropModel: any = null;

    public constructor() {
        this.registerEventListener();
        this.tableCannotPasteTip = CPUtils.tableCannotPasteTipFun();
        this.storeManager = new StoreManager();
        this.imageEditManager = ImageEditManager.getInstance();

        this.pasteSdkHandler = new PasteSdkHandler(this.storeManager);
    }

    public setInject(copyPasteInjectable: ICopyPasteInjectable): void {
        this.copyPasteInjectable = copyPasteInjectable;
        this.clipboardManager = new ClipboardManager(this, copyPasteInjectable);
        this.imageEditManager.enableImageRecovery = copyPasteInjectable.enableImageRecovery;
    }

    public copyText(text = ''): void {
        this.copyDataToText(TextType.TEXT, text);
        this.clipboardManager.write();
    }

    public successWrite(): void { }
    public failWrite(): void { }
    public finallyWrite(clipboardData: ClipboardData, needCleanBase64Map = true): void {
        this.removeEleIfIsCut();
        if (needCleanBase64Map) {
            this.storeManager.base64UrlTempMap.clear();
        }
    }

    /**
     * Safari 异步写入剪贴板申请权限实现方式
     * @returns {Promise<any>}
     */
    public getUserPermissionToCopyData(): Promise<any> {
        return new Promise((resolve, reject) => {
            showTipToCopyCustomerDataToImage(resolve, reject);
        });
    }

    /**
     * 执行文字选择性粘贴逻辑
     * @param sdkData 文字 sdk 数据
     * @param keepProps 是否保留文字属性
     * @returns
     */
    public runTextSelectivePaste(sdkData: DeepPartial<IShapeData>, keepProps = true) {
        const currentModel = this.services?.selectionService?.selectedElements.getCurrentModel();
        if (isEmptyModel(currentModel)) {
            // 说明不是在文本编辑态的粘贴，那么就是直接粘贴为新文本框触发的选择性粘贴
            pasteTextDataAsNewShape(sdkData as IShapeData);
            // 粘贴完进入编辑态，用于定位粘贴选项按钮的位置
            const textEditor = this.services?.selectionService?.selectedElements.getCurrentModel().editorInstance;
            textEditor?.setFocus();
            return;
        }
        const [model] = this.storeManager.selectedElements;
        if (isShapeModel(model) || model.type === UIModelType.CHART) {
            this.useElementPaste(model, sdkData, keepProps);
            return;
        }

        if (isTableModel(model)) {
            const cellModel = model.getEditingCellModel();
            cellModel && this.useElementPaste(cellModel, sdkData, keepProps);
            return;
        }
    }

    public registerEventListener(): void {
        if (ua.isIOS || browser.isSafariVersionBelow(14)) {
            this.textarea.element.addEventListener('copy', e => this.copy(e));
            this.textarea.element.addEventListener('paste', e => this.pasteByEvent(e));
            this.textarea.element.addEventListener('cut', e => this.cut(e));
            document.body.addEventListener('keyup', (event) => {
                if ((ua.isMac ? !event.metaKey : !event.ctrlKey) && this.textarea.isActive()) {
                    (document.activeElement as HTMLElement).blur();
                }
            });
        }

        window.addEventListener('copy', (e) => {
            if (!this.storeManager.activePointInSideBar && this.enable) {
                this.copy(e);
            }
        }, true);

        window.addEventListener('paste', (e) => {
            if (!this.storeManager.activePointInSideBar && this.enable) {
                this.pasteByEvent(e);
            }
        }, true);

        window.addEventListener('cut', (e) => {
            if (!this.storeManager.activePointInSideBar && this.enable) {
                this.cut(e);
            }
        }, true);

        window.addEventListener('dragleave', (e) => {
            if (this.enable) {
                const bodyH = document.documentElement.clientHeight;
                const bodyW = document.documentElement.clientWidth;
                if (e && (e.x >= bodyW || e.x <= 0
                    || e.y >= bodyH || e.y <= 0)) {
                    this.clearDraggingState();
                }
            }
        }, true);

        window.addEventListener('drop', (e) => {
            const isPlaying = this.getPlayManager()?.isPlaying;
            if (isPlaying) return;  // 演示态不处理拖拽逻辑
            if (this.enable) {
                this.clearDraggingState();
                if (!e.dataTransfer) {
                    return;
                }
                if (!(e.dataTransfer.files?.length)) {
                    return;
                }
                e.preventDefault();
                e.stopPropagation();

                this.onDrop(e);
            }
        }, false);  // false，优先让PPT中图形先接受Drop事件

        eventBus.on(EventKeys.TRIGGER_COPY_EVENT, cb => cb(this.triggerCopyEvent.bind(this)));

        this.copyPasteInjectable?.registerCustomCopyPasteListeners?.(this);

        if (__IS_DEV__ || ENV.IS_TEST) {
            (window as any).ua = ua;
        }
    }

    protected getImgDragoverSnackbarMessage(): string {
        return i18n.t('拖拽到形状或图片上即可填充');
    }

    protected getAudioVideoDragoverSnackbarMessage(): string {
        return i18n.t('拖拽音视频到编辑区域即可插入');
    }

    public clearDraggingState = () => {
        this.dragStatus = {
            isDragged: false,
            enableDrop: false,
        };
        if (this.snackbarOp) {
            this.snackbarOp.close();
            this.snackbarOp = null;
        }
    };

    public triggerCopyEvent(copyValue?: string | undefined): boolean {
        if (this.triggerCopyByTextarea(copyValue) || this.triggerDefaultCopyEvent()) {
            return true;
        }
        window.log.warn('[CopyPasteManager] trigger copy failed');
        return false;
    }

    private triggerDefaultCopyEvent() {
        window.log.info('[CopyPasteManager] try to use execCommand trigger copy');
        return document.execCommand('copy');
    }

    private triggerCopyByTextarea(copyValue = ' ') {
        this.textarea.setValue(copyValue);
        this.textarea.select();
        const n = document.getSelection();
        if (!document.queryCommandEnabled('copy') && n?.isCollapsed) {
            const l = document.createRange();
            l.selectNodeContents(document.body);
            n?.addRange(l);
        }
        window.log.info('[CopyPasteManager] try to use textarea trigger copy');
        return this.triggerDefaultCopyEvent();
    }

    public triggerCutEvent(): void {
        this.isCut = true;
        this.triggerCopyEvent();
    }

    /**
     * 模拟 paste 事件
     * 很遗憾，现在 paste 事件不能通过document.execCommand模拟
     */
    public triggerPasteEvent(): void {
        this.pasteByAction();
    }

    public keyEventCtrl(): void {
        if (!this.storeManager.activePointInShape) {
            this.textarea.select();
        }
    }

    /**
     * 剪贴回调事件
     * @param {Event} event 剪贴事件
     */
    private cut(event: Event): void {
        // 避免只读权限把数据剪切走
        if (this.storeManager.canEdit) {
            this.isCut = true;
        }
        this.copy(event);
    }

    /**
     * 剪贴操作后需要移除元素
     */
    private removeEleIfIsCut(): void {
        if (this.isCut) {
            CPUtils.doCutDelete();
            this.resetCutStatus();
        }
    }

    protected resetCutStatus() {
        this.isCut = false;
    }

    /**
     * 快捷键响应规则
     * 1. 播放态（本地or远程）下，除备注区域外，不响应复制粘贴
     * 2. 其他情况遵守通用快捷键响应规则
     */
    private shouldCopyPasteShortcutKeyActive() {
        const isPlaying = this.getPlayManager()?.isPlaying;
        const lastMouseDownRegion = this.getSelectionService()?.lastMouseDownRegion;
        if (isPlaying) {
            const isEditingNote = lastMouseDownRegion === RegionType.NOTE
                && this.getEditorInstanceService()?.checkEditorIsEditing();
            return isEditingNote;
        }

        if (!this.services?.shortCutKeyManager?.dangerousInstance) {
            // 移动端大部分场景没有快捷键判断，直接不阻塞返回即可
            return true;
        }
        return this.services.shortCutKeyManager.dangerousInstance.shouldShortcutKeyActive();
    }

    /**
     * 是否应该响应复制事件
     */
    protected shouldResponseCopy(copyItem?: CopyItem): boolean {
        if (copyItem?.copyValueStr) {
            copyItem.copyValueMethod();
            return false;
        }

        if (!this.shouldCopyPasteShortcutKeyActive()) return false;

        // 未选中任何元素
        if (CPUtils.isSelectedNone()) return false;

        // 选中的 slide 还在加载中
        if (this.storeManager.selectedSlides.some(slide => slide.preload)
            || this.storeManager.selectedElements.some(e => e.slideRef?.preload)) return false;

        // 私有化触发尝试编辑tips异化逻辑
        if (this.copyPasteInjectable?.disableCopy?.(this)) {
            this.services?.tipsManager?.showCannotCopyTips();
            return false;
        }

        // 如果没有编辑权限，则触发尝试编辑tips
        if (!this.storeManager.canEditAndCopy) {
            this.services?.tipsManager?.showCannotCopyTips();
            return false;
        }
        // loading 状态下不响应
        if (this.getUiDataService()?.presentation.operation.loading) {
            showTipWhenDataNotReady();
            return false;
        }
        return true;
    }

    /**
     * 是否应该响应粘贴事件
     * pc右键菜单粘贴/粘贴到标题/无编辑权限/数据加载中均不响应
     */
    protected shouldResponsePaste(event?): boolean {
        if (!this.shouldCopyPasteShortcutKeyActive()) return false;

        // 标题栏粘贴，走原生行为
        const pasteToTitle = document.activeElement?.id === 'input-title';
        if (pasteToTitle) return false;

        // 选中的 slide 还在加载中
        if (this.storeManager.selectedSlides.some(slide => slide.preload)
            || this.storeManager.selectedElements.some(e => e.slideRef?.preload)) return false;

        if (!this.storeManager.canEdit) {
            this.services?.tipsManager?.showCannotEditTips();
            return false;
        }
        if (this.getUiDataService()?.presentation.operation.loading) {
            showTipWhenDataNotReady();
            return false;
        }
        return true;
    }

    /**
     * 提供给clipboardManager获取map的方法
     */
    public getBase64UrlMap() {
        return this.storeManager.base64UrlTempMap;
    }

    /**
     * 复制回调事件
     * @param {Event} event 复制事件
     */
    protected copy(event: Event) {
        // 非 copyPaste 的 textArea 触发不响应 PPT 的复制流程。因为他不可能触发 cut 事件，也无需重置 cut 状态
        // 文档客户端会使用tencent/clipboard中的default-copy-paste，导致死循环。后续某端命中default-copy-paste逻辑也需要在这里补充
        const triggerCopyEle = event?.target as HTMLElement | undefined;
        if (
            ua.isTencentDocsApp
            || (triggerCopyEle?.tagName === 'TEXTAREA' && triggerCopyEle.id !== this.textarea.element.id)
            || IS_IN_TENCENTCLIPBOARD_COPY_STATUS
        ) {
            return false;
        }

        // textarea的value有2种情况：
        // 1.从浮动工具栏复制文本链接，value是href
        // 2.value是' '，用于触发copy事件。注意不是空串，空串无法触发
        // 写入剪贴板后需清空 textarea 传递的数据
        const copyItem: CopyItem = {
            copyValueStr: this.textarea?.getValue().trim(),
            copyValueMethod: () => setTimeout(() => this.textarea.setValue(''), 0),
        };
        if (!this.shouldResponseCopy(copyItem)) {
            this.resetCutStatus();
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (CPUtils.getEventType(event) === EventType.ClipboardEvent) {
            this.clipboardCopyEvent(event as ClipboardEvent);
        }
    }

    /**
     * 复制粘贴剪贴板处理事件
     * @param {ClipboardEvent} event 剪贴板事件
     */
    protected clipboardCopyEvent(event?: ClipboardEvent) {
        this.clipboardManager.startCopy();
        if (this.storeManager.isSlideListRegion) {
            this.copySlides();
        } else if (this.storeManager.isEditorRegion) {
            // 正在编辑态复制粘贴 或 非编辑态但有复制权限时文本框选中的复制粘贴
            if (this.storeManager.activePointInShape || this.isSelectContentCopy()) {
                this.copyInEditing();
            } else {
                this.copyNoEditing();
            }
        } else if (this.storeManager.isNoteRegion) {
            this.copyInNote();
        }
        this.clipboardManager.write(event);
        this.focusCachedActiveElement();
    }

    /**
     * 复制到备注中
     */
    private copyInNote() {
        const noteModel = this.getSelectionService()?.currentSlide?.noteData?.noteTextBody;
        if (noteModel?.editorInstance) {
            const uiCopyData = this.isCut ? noteModel.editorInstance?.cut() : noteModel.editorInstance?.copy();
            if (uiCopyData) {
                const data = this.storeManager.getTextSelectedAreaCopyData(uiCopyData, noteModel);
                // 这里不用 noteModel 的原因，未失去焦点时数据没落盘，不会更新。
                this.copyDataToHTML(HTMLType.CUSTOM_INHERIT_AND_NO_INHERIT, data);
                this.copyDataToText(TextType.ELEMENT_INHERIT_AND_NO_INHERIT, data);
            }
            this.resetCutStatus();
        } else {
            window.log.info(`note area text editing editorInstance is null info: isEditing:${this.getEditorInstanceService()?.checkEditorIsEditing()}sdkDataType:${(noteModel?.sdkData) ? noteModel.sdkData.type : ''}`);
        }
    }

    /**
     * 元素未编辑状态下的复制
     */
    private copyNoEditing() {
        const elements = this.storeManager.selectedElements;
        this.copyPlaceholderDataToText();
        this.copyElementDataToImage(elements);
        if (elements?.length === 1) {
            // 选中一个元素的时候
            this.copyNoEditingWithSingleElement(elements[0]);
        } else {
            this.copyDataToHTML(HTMLType.MULTI_ELEMENT);
        }
    }

    /**
     * 未编辑状态下，只选中单个元素
     * @param element 选中元素
     */
    private copyNoEditingWithSingleElement(element) {
        const { sdkData } = element;
        if (element.type === UIModelType.IMAGE) {
            this.copyDataToHTML(HTMLType.IMAGE);
            if (this.isMedia(sdkData)) {
                this.copyDataToText(TextType.TEXT, i18n.t('您粘贴的区域不支持音频插入。'));
            } else {
                showTipWhenChart(sdkData);
                this.copyDataToText(TextType.TEXT, i18n.t('您粘贴的区域不支持图片插入。'));
            }
        } else if (element.type === UIModelType.TABLE) {
            this.copyNoEditingWithSingleTable();
        } else {
            // 如果是 iframe 第三方插件，需要把链接提取出来
            if (this.isIframeElementFromSdkData(element.sdkData)) {
                this.copyDataToText(TextType.ELEMENT, [element]);
            }
            this.copyDataToHTML(HTMLType.CUSTOM);
        }
    }

    /**
     * 复制未编辑的表格
     * 因为表格存在裁剪，所以这里 copyDataToText 不能传入原始 element
     */
    private copyNoEditingWithSingleTable() {
        if (this.storeManager.useBase64Copy) {
            this.asyncCopyNoEditingWithSingleTable();
            return;
        }
        const tables = this.storeManager.getSelectedElementsCopyData();
        this.copyDataToHTML(HTMLType.TABLE, tables);

        const mockTableModelArr = tables.data.map(sdkData => ({ sdkData })) as ElementBaseModel[];
        this.copyDataToText(TextType.ELEMENT, mockTableModelArr);
    }

    /**
     * 异步复制未编辑的表格
     * 复制文本不存在异步，所以需要通过同比接口把表格内容筛选出来
     * 会多一次拷贝，但是不会显著影响性能
     */
    private asyncCopyNoEditingWithSingleTable() {
        const tablesWithImage = this.storeManager.getSelectedElementsCopyDataToBase64();
        this.copyDataToHTML(HTMLType.TABLE, tablesWithImage);

        const tablesWithoutImage = this.storeManager.getSelectedElementsCopyData();
        const mockTableModelArr = tablesWithoutImage.data.map((sdkData) => {
            let data = sdkData;
            if (ENABLE_PASTE_SPECIAL) {
                data = sdkData.inheritedSdkData;
            }
            return { sdkData: data };
        }) as ElementBaseModel[];
        this.copyDataToText(TextType.ELEMENT, mockTableModelArr);
    }

    /**
     * 文本数据写入剪贴板中
     * @param { TextType } type 文本类型
     * @param { object } data 数据
     */
    protected copyDataToText(type: TextType, data: ElementBaseModel[] | ITextBodyModel | string) {
        let textData;
        if (type === TextType.ELEMENT) {
            textData = data instanceof Array ? data : [];
        } else if (type === TextType.ELEMENT_INHERIT_AND_NO_INHERIT) {
            textData = (data as ITextBodyModel).data;
        } else if (type === TextType.TEXT) {
            textData = typeof data === 'string' ? data : '';
        }
        this.clipboardManager.save({
            [ClipboardType.TEXT]: {
                type,
                data: textData,
            },
        });
    }

    /**
     * 元素数据转图片写入剪贴板
     * @param { Array<ElementBaseModel> } elements 元素集合
     */
    protected copyElementDataToImage(elements: Array<IElementBaseModel>) {}

    /**
     * 幻灯片数据转图片写入剪贴板
     */
    protected copySlideDataToImage() {}

    /**
     * 将指定的slide输出为canvas
     * @param {Array<ISlideModel>} elements slide数组
     * @param {number} resolution 清晰度
     * @param {ImageCanvasOptions} options 是否有默认配置
     * @returns
     */
    public async getSlideDataToCanvas(
        elements: Array<ISlideModel>,
        resolution: number,
        options?: ImageCanvasOptions,
    ): Promise<HTMLCanvasElement> {
        const outputOptions = options || this.getExportCanvasOptions(resolution);
        await this.forceConvertSlides(elements);
        const firstSlide = this.getUiDataService()?.presentation.children.indexOf(elements[0]) === 0;
        // 暂时无解，在mobile端数据拷贝过一次，forceRenderSlides不足以保证顺序
        if (firstSlide && !ua.isPC) {
            await new Promise(resolve => setTimeout(resolve, 500));
        }
        return this.generateSlideCanvas(elements, outputOptions);
    }

    protected abstract generateSlideCanvas(
        slideArray: ISlideModel[],
        imageCanvasOptions: ImageCanvasOptions,
    ): Promise<HTMLCanvasElement>;

    public isForceAsyncModel(): boolean {
        return this.forceAsyncModel;
    }

    /**
     * 生成假canvas所需配置，Safari专用
     * @returns {ImageCanvasOptions}
     */
    getFakeCanvasOptions(): ImageCanvasOptions {
        return {
            slideWidth: 43,
            slideHeight: 27,
            width: 1,
            height: 1,
            scale: 1,
            resolution: 1,
            cloneNode: false,
        };
    }

    /**
     * 导出长图所需canvas配置
     * @param {number} resolution
     * @returns {ImageCanvasOptions}
     */
    getExportCanvasOptions(resolution: number): ImageCanvasOptions {
        return this.getExportCanvasOptionsForCanvas(resolution);
    }

    protected abstract getAspectWIdthBySizeType(slideSizeType: SlideSizeType): number;

    getExportCanvasOptionsForCanvas(resolution: number): ImageCanvasOptions {
        const { slideWidth, slideHeight, slideSizeType } = this.getUiDataService()?.presentation.props ?? {
            slideWidth: 0,
            slideHeight: 0,
            slideSizeType: SlideSizeType.SLIDE_SIZE_4_3,
        };
        const width = this.getAspectWIdthBySizeType(slideSizeType);
        let height;
        if (slideSizeType === SlideSizeType.SLIDE_SIZE_4_3) {
            height = width * (3 / 4);
        } else if (slideSizeType === SlideSizeType.SLIDE_SIZE_16_9) {
            height = width * (9 / 16);
        } else {
            height = width * (slideHeight / slideWidth);
        }
        const scale = width / slideWidth;
        return {
            slideWidth: width,
            slideHeight: height,
            width,
            height,
            scale,
            resolution,
            cloneNode: false,
        };
    }

    /**
     * 复制粘贴生成canvas所需配置
     * @returns {ImageCanvasOptions}
     */
    getCopyCanVasOptions(): ImageCanvasOptions {
        const { slideWidth, slideHeight } = this.getUiDataService()?.presentation.props ?? {
            slideWidth: 0,
            slideHeight: 0,
        };
        const scale = this.services?.editAreaCanvasSizeManager?.getCanvasScale() ?? 1;
        return {
            slideWidth,
            slideHeight,
            width: slideWidth * scale,
            // 会出现页面首次加载选中元素数量0的bug
            height: slideHeight * scale,
            scale,
            resolution: 0.8,
            cloneNode: true,
        };
    }

    public setServiceDelegates(services: Partial<ICopyPasteServiceDelegates>): void {
        // todo: 这块目前把pc的service注入了，需要拆分到pc里，下面还有部分方法依赖pc，也要拆走
        if (!this.services) {
            this.services = services;
        } else {
            this.services = { ...this.services, ...services };
        }
        this.initCPHtml();
        this.imageEditManager.setServicesDelegate(this.services);
        this.clipboardManager.setServicesDelegate(this.services);
        CPUtilsServicesProvider.setServicesDelegate(this.services);
        this.storeManager.setServiceDelegates(this.services);
        this.pasteSdkHandler.setServiceDelegates(this.services);
    }

    private initCPHtml = () => {
        CPHtmlInjectable.checkCanAddIframe = () => !!this.services?.addonManager?.canAddIframeElement();
        CPHtmlInjectable.getCurrentSlideModel = () => this.services?.selectionService?.currentSlide;
        CPHtmlInjectable.getPresentationModel = () => this.services?.uiDataService?.presentation;
    };

    /**
     * 当前选中元素数据转图片写入剪贴板
     * @param { HTMLType } type 写入类型
     * @param { Object } data 写入数据
     */
    private copyDataToHTML(
        type: HTMLType,
        data?: ISdkModel | ITextBodyModel | undefined | Promise<ISdkModel> | IClipboardData,
    ) {
        let copyData = data as IClipboardData;
        if (!copyData) {
            copyData = (
                this.storeManager.useBase64Copy && type === HTMLType.IMAGE
                    ? this.storeManager.getSelectedElementsCopyDataToBase64()
                    : this.storeManager.getSelectedElementsCopyData()
            ) as IClipboardData;
        }
        if (type === HTMLType.SLIDE) {
            this.handleSlideCopyData(copyData);
        }
        // 添加复制的图片、音视频数据
        const presentation = this.storeManager.uiDataService?.presentation.sdkData as IPresentationDataModel;
        copyData.resourceMap = presentation.findUsedResourceMap(copyData);

        this.clipboardManager.save({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [ClipboardType.HTML]: {
                type,
                data: copyData,
                outputOptions: { useAsync: this.storeManager.useBase64Copy },
            } as ElementHTML | ElementInheritHTML,
        });
    }

    /**
     * 处理slide的复制数据，添加主题、母版、版式、备注的复制数据
     */
    private handleSlideCopyData(copyData): void {
        if (!this.storeManager.uiDataService) return;
        const selectedSlideList = this.storeManager.getSelectedArray();
        const copiedNoteList = CopySpecialUtils.getCopiedNoteSdkData(selectedSlideList);
        copyData.noteList = copiedNoteList;
        const list = CopySpecialUtils.getNeedCopiedMasterList(
            selectedSlideList,
            this.storeManager.uiDataService.presentation?.masterList,
        );
        const funcMap = {
            layoutList: CopySpecialUtils.getCopiedLayoutSdkData,
            masterList: CopySpecialUtils.getCopiedMasterSdkData,
            themeList: CopySpecialUtils.getCopiedThemeSdkData,
        };

        Object.keys(funcMap).forEach((key: string) => {
            copyData[key] = funcMap[key](list);
        });
    }

    protected copyPlaceholderDataToText() {}

    /**
     * 编辑中的复制回调
     */
    private copyInEditing() {
        const elements = this.storeManager.selectedElements;
        const [element] = elements as any;
        const shapeModel = this.getSelectedElementModel(element);
        if (shapeModel?.editorInstance) {
            const uiCopyData = this.isCut ? shapeModel.editorInstance?.cut() : shapeModel.editorInstance?.copy();
            if (uiCopyData) {
                const data = this.storeManager.getTextSelectedAreaCopyData(uiCopyData, shapeModel);
                this.copyDataToHTML(HTMLType.CUSTOM_INHERIT_AND_NO_INHERIT, data);
                this.copyDataToText(TextType.ELEMENT_INHERIT_AND_NO_INHERIT, data);
            }
            this.resetCutStatus();
        } else {
            window.log.info(`text editing editorInstance is null info: isEditing:${this.getEditorInstanceService()?.checkEditorIsEditing()}sdkDataType:${element?.sdkData?.type}`);
        }
    }

    private getSelectedElementModel(element) {
        const elementType = element.sdkData.type;
        const shapeType = DataType.Shape;
        const chartType = DataType.GraphicalObjectFrameChart;
        const tableType = DataType.GraphicalObjectFrameTable;
        if (elementType === shapeType || elementType === chartType) {
            return element;
        }
        if (elementType === tableType && element.selectedCellRanges.length) {
            const [selectedRange] = element.selectedCellRanges;
            return element.props.items[selectedRange.rowStart][selectedRange.colStart];
        }
        return;
    }

    /**
     * 复制幻灯片的行为
     * 各个端写剪贴板的行为真是一言难尽:
     * 比如你绝对想不到 mobile chrome 和 mobile wxJsBride 不写入 text 的时候，剪贴板会写入失败
     */
    private copySlides() {
        this.copyDataToHTML(HTMLType.SLIDE);
        this.copyPlaceholderDataToText();
        this.copySlideDataToImage();
    }

    private isExpandEditing(shapeModel) {
        return this.storeManager.isEditorRegion
            && !this.storeManager.activePointInShape
            && shapeModel?.editorInstance?.isExpanded?.()
            && !shapeModel?.editorInstance?.isEditing;
    }

    private isSelectContentCopy() {
        const elements = this.storeManager.selectedElements;
        if (elements?.length !== 1) {
            return false;
        }
        let shapeModel = null;
        // 编辑区
        // 选中一个元素的时候
        const [element] = elements as any;
        const { selectedCellRanges, props } = element;
        const { type } = element.sdkData;
        if (type === DataType.Shape) {
            shapeModel = element;
        } else if (
            (type === DataType.GraphicalObjectFrameTable)
            && selectedCellRanges.length
        ) {
            const [selectedRange] = selectedCellRanges;
            shapeModel = props.items[selectedRange.rowStart][selectedRange.colStart];
        }
        return this.isExpandEditing(shapeModel);
    }

    private async onDrop(event) {
        const priviledgeService = this.getUserPriviledgeService();
        if (priviledgeService && priviledgeService.pptEditorState > PPTEditorStateType.EDITABLE) {
            this.services?.tipsManager?.showCannotEditTips();
            return;
        }

        // 如果当前是B端，就不触发后续所有事件
        if (config.supportEnterprise(EnterPriseType.ALL)) {
            return;
        }

        const currentEvent = CPUtils.getEventType(event);
        const importFilePipelineManager = await (this.services?.importFilePipelineManager?.promise());
        if (currentEvent === EventType.DragEvent || (this.isSafariLower15 && currentEvent === EventType.MouseEvent)) {
            [
                () => ({
                    dragList: this.getDragImgList(event),
                    callback: (images) => {
                        // 标记上传图片的来源
                        if (this.services?.toolbarStateManager) {
                            this.services.toolbarStateManager.lastInsertButtonClick = 3;
                        }
                        const imageEdit = ImageEditManager.getInstance();
                        // 在元素上释放，触发背景填充
                        const { savedDropModel } = this;
                        if (savedDropModel) {
                            this.savedDropModel = null;
                            ImageEditManager.getInstance().imageReplaceAction = 2;
                            imageEdit.bulkReplaceBlobImages(images, savedDropModel);
                        } else {
                            imageEdit.bulkInsertBlobImages(images);
                        }
                        tdw({
                            opername: TDWOperationType.DOC_PPT,
                            module: TDWModuleType.PC_EDIT_INSERT,
                            action: TDWActionType.PASTEP_IMG,
                        });
                    },
                }),
                () => ({
                    dragList: [...this.getDragAudioList(event), ...this.getDragVideoList(event)],
                    callback: (medias) => {
                        medias.forEach((media) => {
                            AttachmentUploader.getInstance().upload({ inputConfig: { file: media } });
                        });
                    },
                }),
                () => ({
                    dragList: getDragPPTList(event),
                    callback: async (pptLists) => {
                        // 如果当前导入流程不处于空闲状态，就不进行新的导入流程
                        if (!importFilePipelineManager?.isFree()) return;
                        // 如果当前有文件正在处理，就不响应新的处理
                        if (pptLists.length !== 1) return;
                        if (!ENABLE_IMPORT_FILE) return;
                        // 需要再进行一次强过滤
                        const [file] = pptLists;
                        if (!isSupportPPTType(file)) {
                            Snackbar.show({
                                message: i18n.t('仅支持.ppt或者.pptx格式，请重新选择'),
                                duration: 3000,
                            });
                            return;
                        }
                        // 如果B账号访问C文档，不显示ImportFileSelectManager,直接insertPage
                        if (isBVisitC()) {
                            this.insertPageImport(pptLists);
                            return;
                        }

                        const importFileSelectManager = await (this.services?.importFileSelectManager?.promise());
                        importFileSelectManager?.updateData({
                            type: 'slide',
                            importFunction: {
                                newPageImport: () => this.newPageImport(pptLists),
                                insertPageImport: () => this.insertPageImport(pptLists),
                            },
                        })
                            .setVisible(true);
                    },
                }),
            ].find((fn) => {
                const dragRes = fn();
                if (!dragRes.dragList.length) return false;
                dragRes.callback(dragRes.dragList);
                return true;
            });
            return;
        }
    }

    // 新建在线幻灯片
    private async newPageImport(pptLists) {
        const importFileSelectManager = await (this.services?.importFileSelectManager?.promise());
        importFileSelectManager?.setVisible(false);
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.DRAG_FILE,
            action: TDWActionType.DRAG_FILE_INSERT,
        });
        this.services?.importNewFileManager?.handleImportFile(pptLists);
    }

    // 插入到当前文档
    private insertPageImport = async (pptLists) => {
        const importFileSelectManager = await (this.services?.importFileSelectManager?.promise());
        importFileSelectManager?.setVisible(false);
        tdw({
            opername: TDWOperationType.PAGING_SELECTION,
            module: TDWModuleType.SLIDE_UPLOAD,
            action: TDWActionType.DRAG_IMPORT,
        });
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.DRAG_FILE,
            action: TDWActionType.DRAG_FILE_NEW,
        });
        this.services?.importFileManager?.promise().then((importFileManager) => {
            importFileManager.parseAndPreviewSlideFile(pptLists[0]);
        });
    };

    /**
     * 快捷键粘贴回调事件
     * @param {Event} event 粘贴事件
     */
    private async pasteByEvent(event: Event) {
        if (!this.shouldResponsePaste(event)) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.services?.menuManager?.hideAllMenu();
        const currentEvent = CPUtils.getEventType(event);
        if (([EventType.ClipboardEvent, EventType.DragEvent] as EventTypeValue[]).includes(currentEvent)) {
            this.doClipboardPaste(event);
        }
    }

    /**
     * 从剪贴板里读取数据
     * TODO 这里没有处理 image/* 相关的数据，有需求再处理
     * @returns
     */
    private async getClipboardBaseData(event?: ClipboardEvent) {
        const clipboardDataMap = await this.clipboardManager.read(event);
        const textPlain = clipboardDataMap[ClipboardType.TEXT] || '';
        const { html: textHtml,
            privateData: privateDataString,
            privateTag,
        } = clipboardDataMap[ClipboardType.HTML] || {};
        return {
            textHtml,
            textPlain,
            privateDataString,
            privateTag,
        };
    }

    /**
     * 从系统级别的剪贴板读取 File[]
     * 仅有系统级别的APP才能创造 FileList
     * @param {ClipboardEvent} event
     * @returns
     */
    private async getImagesFromFileList(event: ClipboardEvent) {
        const files = await this.clipboardManager.readFile(event) || [];
        const validImageType = [
            ClipboardType.IMAGE_PNG, ClipboardType.IMAGE_JPEG,
            ClipboardType.IMAGE_GIF, ClipboardType.IMAGE_BMP, ClipboardType.IMAGE_SVG_XML,
        ];
        return files.filter(file => validImageType.includes(file.type as ClipboardType));
    }

    /**
     * 浏览器不允许 execCommand('paste')，为右键菜单设计
     * 会导致 event.files 区域里的内容读取不到
     * @returns
     */
    public async pasteByAction(): Promise<void> {
        if (!this.shouldResponsePaste()) {
            return;
        }
        this.services?.menuManager?.hideAllMenu();
        this.doClipboardPaste();
    }

    /**
     * 元素背景需要使用剪贴板中的图片替换
     * 优先从剪贴板从私有数据中，其次文件区域取，，最后才是html
     * @param imagesFromFileList 剪贴板文件区域中的图片
     * @param textHtml
     * @param privateData
     * @returns
     */
    private replaceImageToShapeBackground(imagesFromFileList: File[], textHtml, privateData) {
        ImageEditManager.getInstance().clipDataWaiting = false;
        if (this.replaceImageToShapeBackgroundWithPrivateData(privateData)) {
            return;
        }
        this.replaceImageToShapeBackgroundWithPublicData(imagesFromFileList, textHtml);
    }

    /**
     * 元素背景需要使用剪贴板中的私有数据替换
     * 当只选中了1个元素，且元素是图片时可直接复用
     * @param privateData
     */
    private replaceImageToShapeBackgroundWithPrivateData(privateData) {
        let picSdkData = privateData?.data.find(this.isPicFromSdkData);
        if (ENABLE_PASTE_SPECIAL) {
            picSdkData = picSdkData?.inheritedSdkData;
        }
        const isSingleSelect = privateData?.data.length === 1;
        if (isSingleSelect && picSdkData) {
            replaceImage([{
                src: picSdkData.blipFill.blip.embed,
                imageType: picSdkData.imageType,
                width: emuToPt(picSdkData.spPr.xfrm.ext.cx) || 150,
                height: emuToPt(picSdkData.spPr.xfrm.ext.cy) || 150,
            }], this.services?.selectionService?.getSelectedModel());
            return true;
        }
        return false;
    }

    /**
     * 元素背景需要使用剪贴板中的文件区域/html区域
     * @param imagesFromFileList
     * @param textHtml
     * @returns
     */
    private replaceImageToShapeBackgroundWithPublicData(imagesFromFileList: File[], textHtml: any) {
        let imageList: any = imagesFromFileList;
        if (!imageList?.length) {
            const parseRes = ParsePasteHTML.getSingleton().parseHTML(textHtml) || {};
            imageList = parseRes.images?.map(({ url }) => this.clipboardManager.imagePreparePlugin.getImageBlob(url));
        }
        if (!imageList?.length) {
            Snackbar.show({
                message: i18n.t('请复制图片到剪贴板，进行替换'),
                duration: 3000,
            });
            return;
        }

        if (ImageEditManager.getInstance().imageReplaceAction === 3) {
            // 文字的图片填充不走图片秒看逻辑，因为分支功能带来sdk处较为复杂的处理得不偿失
            ImageEditManager.getInstance().uploadWithoutQuickLook(imageList, i18n.t('正在填充图片...'))
                .then((images) => {
                    replaceImage(images, this.services?.selectionService?.getSelectedModel());
                });
        } else {
            ImageEditManager.getInstance().bulkReplaceBlobImages(imageList);
        }
    }

    protected focusCachedActiveElement() {}

    protected async doClipboardPaste(event?: Event | ClipboardEvent) {
        const {
            textHtml,
            textPlain,
            privateDataString,
            privateTag,
        } = await this.getClipboardBaseData(event as ClipboardEvent);
        this.focusCachedActiveElement();
        if (this.copyPasteInjectable.shouldShowOpenClientPaste(privateTag, privateDataString)) {
            SlideDataServices.UI.Snackbar.promise().then((snackbar) => {
                snackbar.show({
                    message: i18n.t('因浏览器限制暂不支持粘贴本地文档图片，建议在腾讯文档客户端操作'),
                    autoClose: true,
                    duration: 5000,
                    closable: true,
                    action: i18n.t('打开客户端'),
                    onClickAction: () => {
                        tdw({
                            opername: TDWOperationType.DOC_PPT,
                            module: TDWModuleType.COPY_PASTE,
                            action: TDWActionType.OPEN_CLIENT,
                        });
                        openWithDesktop(location.href);
                    },
                });
            });
            return;
        }
        const privateData = await this.getPrivateData(privateDataString);
        // 延后执行 getImagesFromFileList, firefox 读取剪切板前，执行等待异步会导致读取剪切板失败
        const imagesFromFileList = await this.getImagesFromFileList(event as ClipboardEvent);
        // 处理图片替换逻辑 add by yunnan
        if (ImageEditManager.getInstance().clipDataWaiting) {
            this.replaceImageToShapeBackground(imagesFromFileList, textHtml, privateData);
            return;
        }
        // 处理图片替换place holder逻辑。单独走imageUploadService的逻辑
        const images = this.getImagesFromPrivateData(privateData);
        if (this.shouldImgReplacePlaceHolder(imagesFromFileList?.length ? imagesFromFileList : images, textHtml)) {
            if (imagesFromFileList?.length) {
                window.log?.info('paste image file list replace placeholder');
                this.imageEditManager.createEditorImages(imagesFromFileList ?? []).then((images) => {
                    this.services?.imageUploadService?.promise().then((instance) => {
                        instance.handleImageChange(images).then(() => {});
                    });
                });
            } else if (images.length) {
                window.log?.info(`paste private data image replace placeholder: ${images}`);
                this.services?.imageUploadService?.promise().then((instance) => {
                    instance.handleImageChange(images).then(() => {});
                });
            }
            return;
        }
        const isTableData = this.isSingleTable(privateData?.data);
        const isPasteTableOnNote = this.storeManager.isNoteRegion && isTableData;
        // 粘贴 表格 到 备注区 时，粘贴文本
        if (privateData && !isPasteTableOnNote) {
            this.pasteFromPrivateData(this.resolvePrivateData(privateData));
        } else {
            this.pasteFromPublicData(textHtml, imagesFromFileList, textPlain);
        }
    }

    private resolvePrivateData(privateData: ISdkModel | ITextBodyModel) {
        // 3.0 文档，3.0数据无需处理
        if (privateData.sdkVersion === CopyDataVersion.Version3) {
            const [{ sdkDataWithoutInherit, sdkDataWithInherit }] = privateData.data;
            if (sdkDataWithoutInherit || sdkDataWithInherit) {
                // 旧数据兼容，说明是添加文字选择性粘贴功能之前复制的文本
                return {
                    ...privateData,
                    data: [{
                        // 这里没写反，旧数据的命名是反的
                        inheritedSdkData: sdkDataWithoutInherit,
                        ownSdkData: sdkDataWithInherit,
                    }],
                };
            }
            return privateData;
        }
        // 3.0 文档，2.0数据进行迁移
        if (privateData.type === DataModel.textBodyModel) {
            return this.migratePrivateTextData(privateData as unknown as ITextBodyModelVersion2);
        }
        return this.migratePrivateModelData(privateData);
    }

    private migratePrivateTextData(privateData: ITextBodyModelVersion2) {
        const migrator = new SlideDataMigrator();
        const [{ sdkDataWithoutInherit: inheritedSdkData, sdkDataWithInherit: ownSdkData }] = privateData.data;
        const { nvPr, spPr, txBody } = migrator.migrateShape(ownSdkData);
        const { nvPr: nvPrO, spPr: spPrO, txBody: txBodyO } = migrator.migrateShape(inheritedSdkData);
        const newSdkDataWithInherit: any = {
            nvPr: nvPrO,
            spPr: spPrO,
            txBody: txBodyO,
        };
        const newSdkDataWithoutInherit: any = {
            nvPr,
            spPr,
            txBody,
        };
        return {
            ...privateData,
            data: [{ inheritedSdkData: newSdkDataWithInherit, ownSdkData: newSdkDataWithoutInherit }],
        };
    }

    private migratePrivateModelData(privateData: ISdkModel) {
        // 不支持的数据类型不进行迁移
        if (privateData.data.some(data => !SupportTypesFromV2toV3.includes(data.type))) {
            this.DataVersionUnMatchTip();
            return { ...privateData, data: [], resourceMap: { audios: {}, fonts: {}, images: {}, videos: {} } };
        }

        const migrator = new SlideDataMigrator();
        migrator.ctx.presentation = { resource: { imageResource: { resourceMap: {} } } };
        const dataV3: ({ ownSdkData: unknown, inheritedSdkData: unknown })[] = [];
        const noteDataV3: ({ ownSdkData: unknown, inheritedSdkData: unknown })[] = [];
        privateData.data.forEach((sdkData) => {
            if (sdkData.type === ComponentsType.SLIDE) {
                const pageData = migrator.migratePage(sdkData, DataType.Slide);
                dataV3.push({ ownSdkData: pageData, inheritedSdkData: _cloneDeep(pageData) });
                const noteData = migrator.migrateNoteSlide(sdkData);
                if (noteData) {
                    noteDataV3.push({ ownSdkData: noteData, inheritedSdkData: _cloneDeep(noteData) });
                }
                return;
            }
            if (sdkData.type === ComponentsType.LAYOUT) {
                const pageData = migrator.migratePage(sdkData, DataType.SlideLayout);
                dataV3.push({ ownSdkData: pageData, inheritedSdkData: _cloneDeep(pageData) });
                return;
            }
            if (sdkData.type === ComponentsType.SECTION) {
                const sectionData = { name: sdkData.name, type: DataType.Section };
                dataV3.push({ ownSdkData: sectionData, inheritedSdkData: _cloneDeep(sectionData) });
                return;
            }
            const shapeData = migrator.migrateElement(sdkData);
            dataV3.push({ ownSdkData: shapeData, inheritedSdkData: _cloneDeep(shapeData) });
        });
        // 更新连接线的id, 保持吸附状态
        migrator.updateConnectionsId();
        const imageResourceMap = migrator.ctx.presentation.resource.imageResource.resourceMap;
        return {
            ...privateData,
            data: dataV3,
            noteList: noteDataV3,
            resourceMap: { audios: {}, fonts: {}, images: { ...imageResourceMap }, videos: {} },
        };
    }

    private async getPrivateData(privateDataString: string) {
        let privateData;
        try {
            const futureImageResources: Promise<ImageResource>[] = [];
            privateData = JSON.parse(privateDataString);
            // 本地编辑图片的复制粘贴有如下问题
            // 1. 选择性粘贴会携带 resourceMap 粘贴，但是本地编辑里多个文档之间的图片 resource id 并不能保证唯一性，跨文档复制有问题
            // 2. 选择性粘贴使用目标主题粘贴时，图片使用 resource id 进行粘贴，但是本地编辑需要根据链接重新下载图片至本地，复制来的 id 无法使用，需要新生成 id
            // 临时解决方法如下：
            // 1. 粘贴至本地编辑时，所有图片的 embed 均替换为实际链接，然后统一下载替换为新 id
            // 2. 粘贴至本地编辑时，不粘贴 resourceMap 信息
            // 3. 粘贴至本地编辑时，视频资源信息不重复上传
            const imageResources = new Map<string, string>();
            // 2.0 文档没有 resourceMap 信息无需额外处理
            if (privateData.sdkVersion === CopyDataVersion.Version3) {
                Object.values(privateData.resourceMap.images).forEach((item: any) => {
                    imageResources.set(item.id, item.src);
                });
                if (this.copyPasteInjectable?.isLocalEdit) {
                    // 本地编辑清除 resourceMap 里的 images / video / audio
                    // images 后续会重新上传；video 和 audio 同文档无需处理，跨文档不支持粘贴也无需处理
                    privateData.resourceMap.images = {};
                    privateData.resourceMap.videos = {};
                    privateData.resourceMap.audios = {};
                } else {
                    // 在线文档清除 resourceMap.images 中本地资源
                    Object.keys(privateData.resourceMap.images).forEach((key) => {
                        if (privateData.resourceMap.images[key].src.includes('tdocs')) {
                            delete privateData.resourceMap.images[key];
                        }
                    });
                }
            }
            privateData = this.parseAndChangeResource(
                JSON.stringify(privateData),
                futureImageResources,
                imageResources,
            );
            // 异步上传并更新图片
            ImageEditManager.getInstance().uploadAndUpdateImages(await Promise.all(futureImageResources));
        } catch (e) {
            window.log?.warn?.('[CopyPaste] clipboard does not have private data', e);
        }
        return privateData;
    }

    /**
     * 仅处理 data 数据
     * 本地文档无需保留 resourceMap
     * 在线文档 resourceMap 无需处理直接复用即可
     * @param dataString
     * @param futureImageResources
     * @param imageResources
     * @returns
     */
    private parseAndChangeResource(
        privateDataString: string,
        futureImageResources: Promise<ImageResource>[],
        imageResources: Map<string, string>,
    ) {
        // 图片资源仅处理一次，防止 inheritedSdkData 和 ownSdkData 中的同一资源被重复处理 <remoteSrc, newId>
        const remoteImageNewId = new Map();
        return JSON.parse(privateDataString, (key, value) => {
            if (!IMAGE_SRC_KEY.includes(key)) {
                // 【smartArt】 粘贴还原NaN与Infinity
                if (typeof value === 'string') {
                    if (value === 'NaN') {
                        return NaN;
                    } if (value === 'Infinity') {
                        return Infinity;
                    } if (value === '-Infinity') {
                        return -Infinity;
                    }
                }
                return value;
            }
            // 无对应资源则保留原 value
            const imageUrl = imageResources?.get(value) ?? value;
            if (remoteImageNewId.has(imageUrl)) {
                return remoteImageNewId.get(imageUrl);
            }

            const imageQuickLook = ImageQuickLookManager.getInstance();
            const resourceId = imageQuickLook.createResourceId(value);
            // base64 添加秒看生成新的 id
            if (ImageUrl.isBase64Url(value)) {
                futureImageResources.push(imageQuickLook.addImageWithBase64Url(value, resourceId));
                remoteImageNewId.set(value, resourceId);
                return resourceId;
            }
            /**
             * 粘贴到本地编辑 或 粘贴到在线文档且资源中包含tdocs本地资源
             * 图片需要下载到本地 并生成新的 id
             */
            if (this.copyPasteInjectable?.shouldDownloadToLocal(imageUrl) || imageUrl.includes('tdocs')) {
                futureImageResources.push(imageQuickLook.addImageWithCDNUrl(imageUrl, resourceId));
                remoteImageNewId.set(imageUrl, resourceId);
                return resourceId;
            }
            return value;
        });
    }

    private uploadImageFromFileList(imagesFromFileList: File[] | undefined, imagesFromHtml: { url: string }[] = []) {
        if (!imagesFromFileList?.length) return;
        // 标记上传图片的来源
        if (this.services?.toolbarStateManager) {
            this.services.toolbarStateManager.lastInsertButtonClick = 3;
        }
        /**
         * 从QQ、微信以及企业微信复制一张图片才会触发bug，剪贴板里的text/html中image数量与Files中的数量不一致，导致插入重复图片
         * 使用之前记录的text/html中image的数量从Files中切割正确的图片数量用以导入
         */
        const imagesList = imagesFromFileList.slice(-imagesFromHtml.length);
        // 上传图片
        ImageEditManager.getInstance().bulkInsertBlobImages(imagesList);
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.PC_EDIT_INSERT,
            action: TDWActionType.PASTEP_IMG,
        });
    }

    /**
     * 从 text/html 中粘贴，且当前已在某个元素中编辑
     * @param element 当前选中元素
     * @param param1 {object} 解析数据
     * @param downgradeWithTextAndImage {function} 从 text/plain、image 中读取数据的降级方法
     * @param downgradeWithAddNewElement {function} 新增元素的降级方法
     */
    private pasteFromHTMLWithSingleEleInEditor(
        element,
        { textSdkData, tableList, images }: { textSdkData?: IShapeData; tableList?: any[]; images?: any[] },
        downgradeWithTextAndImage,
        downgradeWithAddNewElement,
    ) {
        // 选中的是表格且在文字编辑态，按照 office 逻辑，优先解析 table，其次是文本，图片类型忽略
        if (this.elementIsTableAndFocus(element)) {
            if (tableList?.length && element.paste(tableList[0])) {
                return;
            }
            if (textSdkData) {
                this.pasteToTable(element, textSdkData, textSdkData);
                if (this.storeManager.activePointInShape && ENABLE_PASTE_SPECIAL) {
                    // 在编辑态，显示选择性粘贴选项
                    pasteSpecialEventBus.emit(PanelType.TEXT_PASTE_PANEL, {
                        data: [{
                            ownSdkData: textSdkData,
                            inheritedSdkData: textSdkData,
                        }],
                    });
                }
            }
            return;
        }
        // 选中的是形状且没有图片和表格数据，粘贴到形状中
        if (isShapeModel(element) && !tableList?.length && !images?.length) {
            if (textSdkData) {
                this.pasteToShape(element, textSdkData);
                if (this.storeManager.activePointInShape && ENABLE_PASTE_SPECIAL) {
                    // 在编辑态，显示选择性粘贴选项
                    pasteSpecialEventBus.emit(PanelType.TEXT_PASTE_PANEL, {
                        data: [{
                            ownSdkData: textSdkData,
                            inheritedSdkData: textSdkData,
                        }],
                    });
                }
            } else {
                // 没富文本数据就降级为纯文本粘贴，不知道有没有这个场景
                downgradeWithTextAndImage();
            }
            return;
        }
        if (this.elementIsChartAndFocus(element) && textSdkData) {
            this.pasteToChart(element, textSdkData);
            return;
        }
        // 其余场景，都直接粘贴为新元素
        downgradeWithAddNewElement();
    }

    /**
     * 从剪贴板公共数据部分粘贴解析
     * @param textHtml html原始数据
     * @param imagesFromFileList 剪贴板文件区域中的图片
     * @param textPlain plain原始数据
     * @returns
     */
    private pasteFromPublicData(
        textHtml: string,
        imagesFromFileList: File[] | undefined,
        textPlain: string,
    ) {
        if (textHtml?.length || imagesFromFileList?.length) {
            const downgradeHandler = () => this.handlerPublicTextPlain(textPlain);
            this.handlerPublicTextHtml(textHtml, imagesFromFileList, downgradeHandler);
            return;
        }
        if (textPlain?.length) {
            this.handlerPublicTextPlain(textPlain);
            return;
        }
    }

    /**
     * 处理剪贴板里 text/html
     * @param textHtml html 源数据
     * @param imagesFromFileList 从剪贴板 File 列表读取的图片
     * @param uploadImageFromFileList 上传
     */
    private handlerPublicTextHtml(
        textHtml: string,
        imagesFromFileList: File[] | undefined,
        downgradeWithTextPlain: () => boolean,
    ) {
        // 根据逻辑判断，dataList 长度是 0 或 1，所以如果有值，可以直接使用 dataList[0] 获取
        const { dataList, tableList, images }: {
            dataList?: IShapeData[];
            tableList?: any[];
            images?: any[];
        } = ParsePasteHTML.getSingleton().parseHTML(textHtml) || {};
        const elements = this.storeManager.selectedElements;
        const addNewElementByData = () => {
            const textData = dataList?.[0];
            pasteTextDataAsNewShape(textData);
            pasteTables(tableList);
            pasteImageData(this.getSelectionService()?.currentSlide, images);
            const noDataToAdded = !textData && !tableList?.length && !images?.length;
            if (noDataToAdded) {
                // 根据原逻辑整理，只有所有数据都没有的时候才会走这个
                this.uploadImageFromFileList(imagesFromFileList, images);
            }
            if (textData && !tableList?.length && !images?.length && ENABLE_PASTE_SPECIAL) {
                // 只有文字数据，显示选择性粘贴按钮
                const textEditor = this.services?.selectionService?.selectedElements.getCurrentModel().editorInstance;
                textEditor?.setFocus(() => {
                    pasteSpecialEventBus.emit(PanelType.TEXT_PASTE_PANEL, {
                        data: [{
                            ownSdkData: textData,
                            inheritedSdkData: textData,
                        }],
                    });
                });
            }
        };
        const downgradeWithTextAndImage = () => {
            // 优先降级为纯文本粘贴
            if (downgradeWithTextPlain()) {
                return;
            }
            this.uploadImageFromFileList(imagesFromFileList, images);
        };
        if (this.storeManager.isNoteRegion) {
            const model = this.getSelectionService()?.currentSlide?.noteData?.noteTextBody;
            // 有先从HTML中解析出来的数据进行粘贴，如果没有则使用纯文本
            if (dataList?.length) {
                this.useElementPaste(model, dataList[0]);
            } else {
                downgradeWithTextAndImage();
            }
            return;
        }
        if (this.isSingleEleAndFocusInEditor(elements)) {
            this.pasteFromHTMLWithSingleEleInEditor(
                elements[0],
                { textSdkData: dataList?.[0], tableList, images },
                downgradeWithTextAndImage,
                addNewElementByData,
            );
            return;
        }
        if (dataList?.length || tableList?.length || images?.length) {
            addNewElementByData();
            return;
        }
        this.uploadImageFromFileList(imagesFromFileList, images);
    }

    /**
     * 处理剪贴板里 text/plain 的数据
     * @param textPlain plain 源数据
     */
    private handlerPublicTextPlain(textPlain: string) {
        if (!textPlain?.length) return false;
        if (this.storeManager.isEditorRegion) {
            this.handlerPublicTextPlainToShape(textPlain);
        } else if (this.storeManager.isNoteRegion) {
            this.handlerPublicTextPlainToNote(textPlain);
        } else {
            // 未能粘贴到元素内，则粘贴为新文本框
            pastePureTextAsNewShape(textPlain);
        }
        return true;
    }

    private handlerPublicTextPlainToNote(textPlain) {
        const sdkData = generateShapeDataFromText(textPlain);
        const model = this.getSelectionService()?.currentSlide?.noteData?.noteTextBody;
        this.useElementPaste(model, sdkData, false);
    }

    /**
     * 处理 text/plain 粘贴到图形上的情况
     * 1.只有一个元素编辑中、非插件
     *     1.shape
     *     2.表格
     * 2.其余情况是直接插入文本框
     * @param textPlain
     * @returns
     */
    private handlerPublicTextPlainToShape(textPlain: string) {
        const elements = this.storeManager.selectedElements;
        if (this.isSingleEleAndFocusInEditor(elements)) {
            const [element] = elements as any;
            const sdkData = generateShapeDataFromText(textPlain);
            if (this.elementIsShapeAndFocus(element)) {
                this.useElementPaste(element, sdkData, false);
                return;
            }
            if (this.elementIsTableAndFocus(element)) {
                this.pasteToTable(element, sdkData, sdkData, false);
                return;
            }
        }
        pastePureTextAsNewShape(textPlain);
    }

    /**
     * 提供两种粘贴到图形的逻辑
     * 1.光标焦点在图形内使用元素 paste 方法粘贴
     * 2.直接替换元素文本段落
     * @param {IElementBaseModel} elementModel 元素
     * @param {object} sdWI 继承数据
     */
    private pasteToShape(elementModel: IShapeModel, sdkData: IShapeData) {
        if (this.storeManager.activePointInShape) {
            this.useElementPaste(elementModel, sdkData);
            return;
        }
        const newElement = this.convertSdkDataToUiDataWithInheritLogic(sdkData, elementModel);
        elementModel.updateParagraphList(newElement.paragraphList);
    }

    /**
     * 粘贴到图表中的逻辑。目前只存在粘贴到图表标题里
     * 目前只提供有标题焦点的情况下粘贴
     */
    private pasteToChart(elementModel: IElementBaseModel, sdWI) {
        if (this.storeManager.activePointInShape) {
            this.useElementPaste(elementModel, sdWI);
        }
    }

    /**
     * 是否是表格元素并编辑中
     * @param element 元素
     * @returns {boolean}
     */
    private elementIsTableAndFocus(element: IElementBaseModel): element is ITableModel & boolean {
        return isTableModel(element)
            && (this.storeManager.activePointInShape || element.showSelection);
    }

    /**
     * 是否是图表元素并编辑中
     * @param element 元素
     * @returns {boolean}
     */
    private elementIsChartAndFocus(element): boolean {
        return element.type === UIModelType.CHART && this.storeManager.activePointInShape;
    }

    /**
     * 是否是图形元素并编辑中
     * @param element
     * @returns
     */
    private elementIsShapeAndFocus(element) {
        return element.type === UIModelType.SHAPE && this.storeManager.activePointInShape;
    }

    /**
     * 只有一个元素，且上一次编辑焦点在编辑区，而且不是公式
     * @param elements
     * @returns
     */
    private isSingleEleAndFocusInEditor(elements) {
        return elements?.length === 1
            && this.storeManager.isEditorRegion
            && !this.isIframeElementFromSdkData(elements[0].sdkData);
    }

    /**
     * 是否存在支持插入图片的place holder
     * @param elements 选中元素列表
     * @private
     */
    private hasPlaceHolderEleAcceptPic(elements: Array<IElementBaseModel>) {
        return elements?.some?.(model => (model.isPlaceholder && !model.isCustomPlaceholder
                && (model.placeHolder?.type === PlaceHolderMode.PIC || typeof (model.placeHolder?.type) === 'undefined')));
    }

    /**
     * 复制的图片是否用来替换place holder
     * @param imagesFromFileList
     * @private
     */
    private shouldImgReplacePlaceHolder(imagesFromFileList, textHtml) {
        // 检查是否粘贴的文本
        const { dataList, tableList } = ParsePasteHTML.getSingleton().parseHTML(textHtml) || {};
        const noDataToAdded = !dataList?.length && !tableList?.length;

        const elements = this.storeManager.selectedElements;
        return noDataToAdded && imagesFromFileList?.length && this.services?.imageUploadService
        && this.hasPlaceHolderEleAcceptPic(elements);
    }

    private getImagesFromPrivateData(privateData) {
        const images: EditorImage[] = [];
        const { data } = privateData || { };
        if (Array.isArray(data)) {
            data.forEach((element) => {
                const { inheritedSdkData } = element || { };
                // 解析图片
                let src;
                if (inheritedSdkData?.type === DataType.Picture) {
                    src = inheritedSdkData?.blipFill?.blip?.embed;
                } else if (inheritedSdkData?.type === DataType.Shape) {
                    src = inheritedSdkData?.spPr?.blipFill?.blip?.embed;
                }
                const { cx, cy } = inheritedSdkData?.spPr?.xfrm?.ext || { };
                src && images.push({
                    src,
                    imageType: inheritedSdkData?.imageType,
                    prstGeom: { prstGeomType: 'rect' },
                    imageName: '',
                    width: emuToCanvas(cx),
                    height: emuToCanvas(cy),
                });
            });
        }
        return images;
    }

    /**
     * 从私有数据中粘贴，私有数据只有从腾讯文档slide中粘贴才会有
     * @param {object} privateData 私有数据
     */
    private pasteFromPrivateData(privateData: ISdkModel | ITextBodyModel) {
        if (privateData.sdkVersion === CopyDataVersion.Version2 && privateData.data.length <= 0) {
            return;
        }
        if (privateData.type === DataModel.sdkModel) {
            this.pasteSdkModel(privateData);
        } else if (privateData.type === DataModel.textBodyModel) {
            const [{ ownSdkData, inheritedSdkData }] = privateData.data;
            const elements = this.storeManager.selectedElements;
            if (this.isSingleEleAndFocusInEditor(elements)) {
                const [element] = elements as any;
                if (element.type === UIModelType.SHAPE) {
                    this.pasteToShape(element, ownSdkData);
                    if (this.storeManager.activePointInShape && ENABLE_PASTE_SPECIAL) {
                        pasteSpecialEventBus.emit(PanelType.TEXT_PASTE_PANEL, privateData);
                    }
                    return;
                }

                if (this.elementIsChartAndFocus(element)) {
                    this.pasteToChart(element, ownSdkData);
                    return;
                }

                if (this.elementIsTableAndFocus(element)) {
                    this.pasteToTable(element, inheritedSdkData, ownSdkData);
                    if (this.storeManager.activePointInShape && ENABLE_PASTE_SPECIAL) {
                        pasteSpecialEventBus.emit(PanelType.TEXT_PASTE_PANEL, privateData);
                    }
                    return;
                }
                return;
            }
            if (this.storeManager.isNoteRegion) {
                const model = this.getSelectionService()?.currentSlide?.noteData?.noteTextBody;
                this.useElementPaste(model, ownSdkData);
                return;
            }
            pasteTextDataAsNewShape(ownSdkData);
            const textEditor = this.services?.selectionService?.selectedElements.getCurrentModel().editorInstance;
            textEditor?.setFocus(() => {
                pasteSpecialEventBus.emit(PanelType.TEXT_PASTE_PANEL, privateData);
            });
        }
    }

    /**
     * 调用文本编辑态的粘贴逻辑
     * @param {IElementBaseModel} elementModel 元素
     * @param {object} pasteSdkData 粘贴数据
     */
    private useElementPaste(elementModel: IElementBaseModel, pasteSdkData, keepProps = true) {
        const newElement = this.convertSdkDataToUiDataWithInheritLogic(pasteSdkData, elementModel);
        (elementModel as any)?.editorInstance?.paste?.(newElement, keepProps);
    }

    /**
     * 把传入的文本 sdkData 应用 targetElement 的继承逻辑后转为 文本 ui 数据
     * @param sdkData
     * @param targetElement
     * @returns
     */
    private convertSdkDataToUiDataWithInheritLogic(sdkData: IShapeData, targetElement: IElementBaseModel): IShapeModel {
        const shapeModel = {} as unknown as IShapeModel;
        const sdkDataBeforeInherit = _cloneDeep(sdkData);
        let sdkDataAfterInherit = sdkData;
        // 计算行高的时候需要完成的继承属性，但是复制粘贴过来的只是单纯的自定义属性，没有继承的行高等数据
        // 而3.0的editor-model已不具备整合styleList获取行高的能力，所以需要在这就集成上
        if (sdkDataAfterInherit?.txBody && targetElement.slideRef) {
            const ph = targetElement.sdkData?.type !== DataType.GroupShape && targetElement.sdkData?.props?.nvPr?.ph;
            if (ph) {
                // 目标元素是占位符的话需要ph信息，这样继承的才是对应目标的样式
                sdkDataAfterInherit.nvPr = sdkDataAfterInherit.nvPr || {};
                // @ts-ignore
                sdkDataAfterInherit.nvPr.ph = ph;
            }
            // eslint-disable-next-line max-len
            sdkDataAfterInherit = ShapePropertyConverter.appendSdkDataInheritProp(sdkDataAfterInherit, targetElement.slideRef) as IShapeData;
        }
        if (targetElement.type === UIModelType.CHART) {
            ShapeModel.convertDataSdkToUi(sdkDataAfterInherit, shapeModel, undefined);
        } else {
            // eslint-disable-next-line max-len
            Object.getPrototypeOf(targetElement).constructor.convertDataSdkToUi(sdkDataAfterInherit, shapeModel, targetElement.sdkData);
        }

        // 通过sdk原始数据与继承后的对比，将自有的属性打标，用来做数据提交时剔除继承属性
        TextConverter.sdkToUiSignRawTextProps(sdkDataBeforeInherit.txBody, shapeModel);
        return shapeModel;
    }

    /**
     * 粘贴到表格中，优先覆盖选区
     */
    private pasteToTable(
        tableModel: ITableModel,
        textDataWithInherit: IShapeData,
        ownTextData: IShapeData,
        keepProps = true,
    ) {
        if (this.storeManager.activePointInShape && tableModel.selectedCellRanges.length) {
            const model = tableModel.getEditingCellModel()!;
            this.useElementPaste(model, ownTextData, keepProps);
        } else {
            tableModel.paste({
                ...textDataWithInherit,
                type: DataType.Shape,
            });
        }
        return;
    }

    private isPasteInTable(elements) {
        return this.isSingleTable(elements)
            && this.elementIsTableAndFocus(elements[0])
            && this.storeManager.isEditorRegion;
    }

    private isHasSmartArData(privateData) {
        const sdkType = DataType.GraphicalObjectFrameSmartArt;
        const { data } = privateData;
        // 检查 data 是否为一个数组
        if (!Array.isArray(data)) {
            return false;
        }
        // 遍历 data 数组
        for (const item of data) {
            // 检查元素本身
            if (item?.ownSdkData) {
                if (item.ownSdkData.type === sdkType) {
                    return true;
                }
            }

            // 检查 item 是否包含 inheritedSdkData 和 ownSdkData 属性
            if (item?.ownSdkData?.cSld?.spTree?.shapeList) {
                const { shapeList } = item.ownSdkData.cSld.spTree;

                // 遍历 shapeList 数组，检查是否有 type 为 17 的元素
                for (const shape of shapeList) {
                    if (shape.type === sdkType) {
                        return true; // 找到 type 为 17 的元素，返回 true
                    }
                }
            }
        }
        return false;
    }

    private pasteSdkModel(privateData: ISdkModel) {
        const elements = this.storeManager.selectedElements;
        // console.log(privateData,'???',this.isHasSmartArData(privateData));
        // [SMART_ART 粘贴限制]如果粘贴的元素是smartArt且当前环境是桌面端本地编辑，则无法粘贴（原因是目前本地编辑的导入导出服务落后，后续发布更新包后可放开）
        if ((!!getQuery('local_edit')) && browser.isTencentDocDesktopApp && this.isHasSmartArData(privateData)) {
            showTipWhenIsSmartArt();
            return;
        }

        if (this.isPasteInTable(elements)) {
            const [element] = elements as any;
            const [{ inheritedSdkData: tableData }] = privateData.data;
            CPUtils.extractTblRangeData(tableData);
            if (!element.paste(tableData)) {
                // 不能粘贴提示
                this.tableCannotPasteTip();
            }
        } else {
            const tempData = privateData as IClipboardData;
            this.pasteSdkHandler.pasteSdkDataOmitTable(tempData);
        }
    }

    /**
     * 强制slide的数据转换
     * @param {Array<SlideModel>} slides
     * @returns
     */
    private forceConvertSlides(slides: ISlideModel[] = this
        .getUiDataService()?.presentation?.children || []): Promise<any> {
        return Promise.all(slides
            .map(async (slide) => {
                !slide.childrenConverted && await slide.startConvertChildrenTask(TaskPriority.HIGH);
            }));
    }


    /**
     * 元素只有一个且是表格
     * @param data
     * @returns
     */
    private isSingleTable(data) {
        if (data?.length !== 1) return false;
        const sdkType = DataType.GraphicalObjectFrameTable;
        let eleType;
        if (ENABLE_PASTE_SPECIAL) {
            eleType = data[0].sdkData?.type || data[0].ownSdkData?.type;
        } else {
            eleType = data[0].sdkData?.type || data[0].type;
        }
        return eleType === sdkType;
    }

    private isPicFromSdkData(sdkData) {
        const data = ENABLE_PASTE_SPECIAL ? sdkData.inheritedSdkData : sdkData;
        return data?.type === DataType.Picture && data?.blipFill?.blip?.embed;
    }

    private isIframeElementFromSdkData(sdkData) {
        return sdkData.type === ComponentsType.SHAPE && sdkData.props?.addon?.displayMode === 'iframe';
    }

    private isMedia(sdkData) {
        return sdkData.audio || sdkData.video;
    }

    private DataVersionUnMatchTip() {
        if (this.snackbarOp) this.snackbarOp.close();
        this.snackbarOp = Snackbar.show({
            message: i18n.t('很抱歉，复制的数据不支持粘贴'),
            duration: 3000,
            autoClose: true,
        });
    }

    /**
     * 用于 drop 事件后过滤非图片文件
     * @param {*} event
     * @returns
     */
    protected getDragImgList(event) {
        return dragBaseLogic(event, (files: File[]) => Array.from(files)
            .filter(file => this.isSupportImageType4ParseCopyImgs(file.type)));
    }

    /**
     * 用于 drop 事件后过滤非视频文件
     * @param {*} event
     * @returns
     */
    protected getDragVideoList(event) {
        return dragBaseLogic(event, (files: File[]) => Array.from(files)
            .filter(file => file.type.startsWith('video/')));
    }

    /**
     * 用于 drop 事件后过滤非音频文件
     * @param {*} event
     * @returns
     */
    protected getDragAudioList(event) {
        return dragBaseLogic(event, (files: File[]) => Array.from(files)
            .filter(file => file.type.startsWith('audio/')));
    }

    /**
     * 判断 safari 浏览器版本，用于拖拽上传时的判断
     */
    private judgeSafariVersion() {
        if (ua.isSafari) {
            const safariVersion = navigator.userAgent?.match(/Version\/([\d.]+)/);
            if (safariVersion && parseFloat(safariVersion[1]) < 15) return true;
        }
        return false;
    }

    /**
     * 是否是支持的图片类型
     */
    private isSupportImageType4ParseCopyImgs(type) {
        const typeList = FILE_TYPE.image.map(item => `image/${item}`);
        return typeList.includes(type);
    }

    private getUiDataService() {
        return this.services?.uiDataService;
    }

    private getSelectionService() {
        return this.services?.selectionService;
    }

    protected getPlayManager() {
        return this.services?.playManager;
    }

    private getUserPriviledgeService() {
        return this.services?.userPriviledgeService;
    }

    private getEditorInstanceService() {
        return this.services?.editorInstanceService;
    }
}

const disableDrop = (e: { dataTransfer: { dropEffect: string } }): string => (e.dataTransfer.dropEffect = 'none');
const enableDrop = (e: { dataTransfer: { dropEffect: string } }): string => (e.dataTransfer.dropEffect = 'copy');
export const testObj = {
    disableDrop,
    enableDrop,
};
